/**
 * Copy Link to Clipboard
 *
 * Handles the "copy link" share button in single post templates.
 * Uses navigator.clipboard with textarea fallback for older browsers.
 *
 * @package Michela_Franceschina
 * @since 1.9.1
 */

(function () {
    document.addEventListener('DOMContentLoaded', function () {
        const copyButton = document.querySelector('.share-copy');
        if (!copyButton) return;

        copyButton.addEventListener('click', function () {
            const url = this.dataset.url;
            const originalHTML = copyButton.innerHTML;

            function onSuccess() {
                copyButton.innerHTML = (window.MFCore && window.MFCore.icon)
                    ? window.MFCore.icon('check')
                    : '';
                copyButton.classList.add('copied');
                copyButton.setAttribute('aria-label', copyButton.dataset.labelCopied || 'Link copiato!');

                // Announce to screen readers via live region
                const status = document.querySelector('.share-status');
                if (status) {
                    status.textContent = 'Link copiato negli appunti.';
                }

                setTimeout(function () {
                    copyButton.innerHTML = originalHTML;
                    copyButton.classList.remove('copied');
                    copyButton.setAttribute('aria-label', copyButton.dataset.label || 'Copia link');
                    if (status) status.textContent = '';
                }, 2000);
            }

            if (navigator.clipboard) {
                navigator.clipboard.writeText(url).then(onSuccess).catch(function () {
                    fallbackCopy(url, onSuccess);
                });
            } else {
                fallbackCopy(url, onSuccess);
            }
        });
    });

    function fallbackCopy(url, onSuccess) {
        const textArea = document.createElement('textarea');
        textArea.value = url;
        textArea.style.cssText = 'position:fixed;left:-9999px;top:-9999px;';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
            onSuccess();
        } catch (err) {
            console.error('Copy failed:', err);
        }
        document.body.removeChild(textArea);
    }

})();

export {};
